export default "__VITE_ASSET__4bd52f29__"